import React from "react";
import RichText from "components/rich-text";
import Link from "components/link";
import Image from "components/image";

const ContactInfo = ({ data }) => (
	<div className=" max-w-4xl mx-auto">
		<h2 className="w-full text-center px-8 md:px-34">{data.title}</h2>
		<div className="py-16 flex justify-between flex-col md:flex-row gap-y-10">
			{data.content && <RichText data={data} />}
			<div className="flex flex-col gap-2">
				{data.contactItems.map((info) => (
					<div key={info._key}>
						<div className="flex gap-2 items-start">
							<div className="min-w-5 w-5 flex pt-1">
								<Image image={info.icon} />
							</div>
							<Link to={info.icon?.url} className=" text-base">
								{info.text}
							</Link>
						</div>
					</div>
				))}
			</div>
		</div>
	</div>
);

export default ContactInfo;